/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Token_Pasted_ToastInputs */

const en_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live captioning token pasted.`)
};

const fr_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeton de sous-titrage en direct collé.`)
};

const de_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelungstoken eingefügt.`)
};

const it_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token per la sottotitolazione in tempo reale incollato.`)
};

const ru_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Токен для субтитров в реальном времени вставлен.`)
};

const es_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha pegado el token de subtítulos en directo.`)
};

const zh_cn2_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已粘贴实时字幕令牌。`)
};

const ja_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプショントークンが貼り付けられました。`)
};

const hi_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग टोकन पेस्ट किया गया।`)
};

const pt_pt2_live_caption_token_pasted_toast = /** @type {(inputs: Live_Caption_Token_Pasted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token de legendagem ao vivo colado.`)
};

/**
* | output |
* | --- |
* | "Live captioning token pasted." |
*
* @param {Live_Caption_Token_Pasted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_token_pasted_toast = /** @type {((inputs?: Live_Caption_Token_Pasted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Token_Pasted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_token_pasted_toast(inputs)
	if (locale === "de") return de_live_caption_token_pasted_toast(inputs)
	if (locale === "it") return it_live_caption_token_pasted_toast(inputs)
	if (locale === "ru") return ru_live_caption_token_pasted_toast(inputs)
	if (locale === "es") return es_live_caption_token_pasted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_token_pasted_toast(inputs)
	if (locale === "ja") return ja_live_caption_token_pasted_toast(inputs)
	if (locale === "hi") return hi_live_caption_token_pasted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_token_pasted_toast(inputs)
	return en_live_caption_token_pasted_toast(inputs)
});